import { Book, BookOpen, Circle } from "react-feather"

export default [
    {
        id: "library",
        title: "Номын сан",
        // icon: <i className="fal fa-library"></i>,//
        icon: <BookOpen size={20} />,
        // navLink: "./service/order/library",
        children: [
            {
                id: "orderbook",
                title: "Номын сангийн үйлчилгээ",
                icon: <Circle size={8}/>,
                navLink: "service/order/book",
            },
            // {
            //     id: "orederlibrary",
            //     title: "Номын сан",
            //     icon: <Circle size={8}/>,
            //     navLink: "service/order/library",
            // },
            {
                id: 'orderlibrary',
                title: 'Номын сангийн каталог',
                icon: <Circle size={8} />,
                navLink: "order/book/librarycatalog",
            },
        ]
    },
]
